import {FC} from 'react'

const Error404: FC = () => {
  return (
    <div style={{ marginTop: '10%' }}>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Không tìm thấy trang</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Trang bạn xem không được tìm thấy! Quay lại trang chủ
      </div>
    </div>
  )
}

export {Error404}
